
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-75 -40 120 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M-75-40H45v80H-75z"}}),_c('path',{attrs:{"fill":"#01411C","d":"M-45-40h90v80h-90z"}}),_c('circle',{attrs:{"r":"24","fill":"#fff"}}),_c('circle',{attrs:{"r":"22","cx":"-7","cy":"-40","fill":"#01411C","transform":"rotate(-41.634 45 -40)"}}),_c('path',{attrs:{"fill":"#fff","d":"M8.751-17.959l10.11 11.373L3.997-9.844l13.94-6.1-7.692 13.129z"}})])
          )
        }
      }
    